import {Injectable} from '@angular/core';
import {GetTopByTypeDto, GetTopByTypeResponse} from './dto/get-top-by-type.dto';
import {HttpService} from '../http.service';
import {STREAMING_ROUTE} from '../http-routes';
import {SportTypeService} from '@api/services/sport-type/sport-type.service';
import {SportType} from '@lib/models/sport-type/sport-type';
import {EntityType} from '@lib/models/entity/entity-type';

@Injectable({
  providedIn: 'root'
})
export class TrendingHttpService {

  constructor( private http: HttpService ) { }

  public async getTopByType(
    entityType: EntityType, skip = 0, limit = 0,
    queryParams?: { stateId?: string },
  ): Promise<GetTopByTypeDto[]> {
    const query = [];
    if (queryParams?.stateId) {
      query.push(`stateid=${queryParams.stateId}`);
    }

    const route = SportTypeService.selectedSportType === SportType.Football ?
      'football/top' : 'handball/top'
    const response = await this.http.get<GetTopByTypeResponse>(
      [STREAMING_ROUTE, route, entityType, skip, limit], query
    );
    return response.data;
  }

  public async getTopByLeague(
    id: string, skip = 0, limit = 0
  ): Promise<GetTopByTypeDto[]> {
    const response = await this.http.get<GetTopByTypeResponse>(
      ['handball/leagues/teams', id, skip, limit]
    );
    return response.data;
  }
}
